import Vue from 'vue';

export function stripHtml(value: any) {
  return value?.replace(/(<([^>]+)>)/gi, '');
}

Vue.filter('stripHtml', stripHtml);
